<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="100px"
        :rules="rules">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$parent.Subflag + '名称'" prop="name"><el-input v-model="formParameter.name"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="难易等级" prop="level">
              <select-option-dictionary v-model="formParameter.level"
                    dkey="level"></select-option-dictionary></el-form-item>
          </el-col>
          <el-col  v-if="$parent.Subflag=='模块'"    :span="8">
            <el-form-item label="归属" prop="type">
              <select-option-dictionary v-model="formParameter.type"
                    dkey="model_type"></select-option-dictionary></el-form-item>
          </el-col>
       
         </el-row>
          <el-row>
          <el-col :span="12" v-if="$parent.Subflag == '科目'">
            <el-form-item :label="$parent.Subflag + '天数'" prop="days"><el-input v-model="formParameter.days"
                oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" maxlength="4" autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="12">
                修改科目天数，会自动更新模块、课程天数
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remk"><el-input v-model="formParameter.remk"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">修 改</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/edu/subject/subject.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
export default {
  name: "edit",
  components: {
    popup,
    selectOptionDictionary,
  },
  data() {
    return {
      urlNum: 1,
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: { },
      rules: {
        //名称
        name: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 100,
            trigger: "blur",
          },
        ],
        //等级
        level: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 2,
            trigger: "blur",
          },
        ],
        //排序
        sort: [
          {
            validator: this.$validate.length,
            max: 2,
            trigger: "blur",
          },
        ],
        //备注
        remk: [
          // {
          //   validator: this.$validate.required,
          //   trigger: "blur",
          // },
          {
            validator: this.$validate.length,
            max: 200,
            trigger: "blur",
          },
        ],
        //课程天数
        days: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 11,
            trigger: "blur",
          },
        ]
       
      },
    };
  },
  methods: {
   
    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      this.formParameter = { },

      
      this.disabled = disabled;
      this.$refs.popup.open(title, 1100);
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
     
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        if (!this.parameter.id) {
          //添加
          // JSON.parse(response.data.content)
          this.formParameter.pid = this.parameter.pid;
          let parameter = this.$utils.merger({sort:this.parameter.maxSort+1},this.formParameter);
          api.save(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else {
          //编辑
          let parameter = this.$utils.merger(this.formParameter);
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        }
      });
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = { };
      //清楚校验
      this.$refs.form.clearValidate();

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data;
        });
        this.popupLoading = false;
      } else {
        //添加
        this.popupLoading = false;
        this.formParameter.level = this.parameter.level?this.parameter.level:1
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>